import axios from 'axios';
import { getEndpoint, ENDPOINTS } from '@busuu/endpoints';
import { isCountryGDPRProtected } from '@busuu/countries';
import { getParameter } from '@busuu/query-params';
import { getSnowplowDuid } from '@busuu/tracking';
import Cookies from 'js-cookie';
import { removeStorageItem, setStorageItem, getStorageItem } from '@busuu/browser-storage';

/* eslint-disable */
// @ts-nocheck
// Private vars
var BRAZE_SCRIPT_PATH = 'https://js.appboycdn.com/web-sdk/4.0/braze.min.js';
/**
 * Loads the Braze script
 *
 * NB: Currently no way to disable TS for a specific block.
 * We do not want to edit a script block from a vendor but we
 * want to keep TS support in general for the `loadBrazeScript` function.
 *
 * @public
 */
var loadBrazeScript = function () {
    try {
        (function (a, p, P, b, y) {
            a.braze = {};
            a.brazeQueue = [];
            for (var s = 'BrazeSdkMetadata DeviceProperties Card Card.prototype.dismissCard Card.prototype.removeAllSubscriptions Card.prototype.removeSubscription Card.prototype.subscribeToClickedEvent Card.prototype.subscribeToDismissedEvent Card.fromContentCardsJson Banner CaptionedImage ClassicCard ControlCard ContentCards ContentCards.prototype.getUnviewedCardCount Feed Feed.prototype.getUnreadCardCount ControlMessage InAppMessage InAppMessage.SlideFrom InAppMessage.ClickAction InAppMessage.DismissType InAppMessage.OpenTarget InAppMessage.ImageStyle InAppMessage.Orientation InAppMessage.TextAlignment InAppMessage.CropType InAppMessage.prototype.closeMessage InAppMessage.prototype.removeAllSubscriptions InAppMessage.prototype.removeSubscription InAppMessage.prototype.subscribeToClickedEvent InAppMessage.prototype.subscribeToDismissedEvent InAppMessage.fromJson FullScreenMessage ModalMessage HtmlMessage SlideUpMessage User User.Genders User.NotificationSubscriptionTypes User.prototype.addAlias User.prototype.addToCustomAttributeArray User.prototype.addToSubscriptionGroup User.prototype.getUserId User.prototype.incrementCustomUserAttribute User.prototype.removeFromCustomAttributeArray User.prototype.removeFromSubscriptionGroup User.prototype.setCountry User.prototype.setCustomLocationAttribute User.prototype.setCustomUserAttribute User.prototype.setDateOfBirth User.prototype.setEmail User.prototype.setEmailNotificationSubscriptionType User.prototype.setFirstName User.prototype.setGender User.prototype.setHomeCity User.prototype.setLanguage User.prototype.setLastKnownLocation User.prototype.setLastName User.prototype.setPhoneNumber User.prototype.setPushNotificationSubscriptionType InAppMessageButton InAppMessageButton.prototype.removeAllSubscriptions InAppMessageButton.prototype.removeSubscription InAppMessageButton.prototype.subscribeToClickedEvent automaticallyShowInAppMessages destroyFeed hideContentCards showContentCards showFeed showInAppMessage toggleContentCards toggleFeed changeUser destroy getDeviceId initialize isPushBlocked isPushPermissionGranted isPushSupported logCardClick logCardDismissal logCardImpressions logContentCardsDisplayed logCustomEvent logFeedDisplayed logInAppMessageButtonClick logInAppMessageClick logInAppMessageHtmlClick logInAppMessageImpression logPurchase openSession requestPushPermission removeAllSubscriptions removeSubscription requestContentCardsRefresh requestFeedRefresh requestImmediateDataFlush enableSDK isDisabled setLogger setSdkAuthenticationSignature addSdkMetadata disableSDK subscribeToContentCardsUpdates subscribeToFeedUpdates subscribeToInAppMessage subscribeToSdkAuthenticationFailures toggleLogging unregisterPush wipeData handleBrazeAction'.split(' '), i = 0; i < s.length; i++) {
                for (var m = s[i], k = a.braze, l = m.split('.'), j = 0; j < l.length - 1; j++)
                    k = k[l[j]];
                k[l[j]] = new Function('return function ' + m.replace(/\./g, '_') + '(){window.brazeQueue.push(arguments); return true}')();
            }
            window.braze.getCachedContentCards = function () {
                return new window.braze.ContentCards();
            };
            window.braze.getCachedFeed = function () {
                return new window.braze.Feed();
            };
            window.braze.getUser = function () {
                return new window.braze.User();
            };
            (y = p.createElement(P)).type = 'text/javascript';
            y.src = BRAZE_SCRIPT_PATH;
            y.async = 1;
            (b = p.getElementsByTagName(P)[0]).parentNode.insertBefore(y, b);
        })(window, document, 'script');
    }
    catch (e) {
        console.error('Cannot load Braze', e);
    }
};

/* eslint-disable consistent-return */
// Private vars
var SDK_ENDPOINT = 'sdk.iad-01.braze.com';
/**
 * Checks if Braze is present on the window object
 * @returns  {Boolean}
 * @private
 */
var isBrazeOnWindow = function () {
    var loaded = Boolean(window.braze);
    if (!loaded) {
        console.warn('isBrazeOnWindow() - Braze has not been found on the window.');
        return false;
    }
    return loaded;
};
/**
 * Initializes the Braze instance and conditionally enables logging for local env
 * @param {Boolean} enableLogs Enable logs
 * @param {String} appVersion Current app version
 * @private
 */
var initializeBraze = function (apiKey, enableLogs, appVersion) {
    if (!isBrazeOnWindow()) {
        return false;
    }
    var brazeConfig = {
        baseUrl: SDK_ENDPOINT,
        enableLogging: enableLogs,
        appVersion: appVersion,
        doNotLoadFontAwesome: true,
        allowUserSuppliedJavascript: true,
    };
    window.braze.initialize(apiKey, brazeConfig);
};
/**
 * Detects if Push API is supported by the current browser
 * @returns {Boolean}
 * @public
 */
var isBrazePushSupported = function () {
    if (!isBrazeOnWindow()) {
        return false;
    }
    return window.braze.isPushSupported();
};
/**
 * Requests permission to show notifications
 * @callback onSuccess callback function executed if user grants permission
 * @callback onBlock callback function executed if user blocks permission
 * @public
 */
var requestBrazePushPermission = function (onSuccess, onBlock) {
    if (!isBrazeOnWindow()) {
        return false;
    }
    window.braze.requestPushPermission(function () {
        // User granted permission
        onSuccess();
    }, function (isTempDenial) {
        if (isTempDenial) {
            // User closed permission box, do nothing
            return;
        }
        // User selected block, execute on denial callback
        onBlock();
    });
};
/**
 * Detects if user has granted permission to show notifications
 * @returns {Boolean}
 * @public
 */
var isBrazePushPermissionGranted = function () {
    if (!isBrazeOnWindow()) {
        return false;
    }
    return window.braze.isPushPermissionGranted();
};
/**
 * Detects if user has blocked permission to show notifications
 * @returns {Boolean}
 * @public
 */
var isBrazePushBlocked = function () {
    if (!isBrazeOnWindow()) {
        return false;
    }
    return window.braze.isPushBlocked();
};
/**
 * Opens new session
 * Automatically sends push registration to Braze backend if user
 * previously granted permission
 * @public
 */
var openBrazeSession = function () {
    if (!isBrazeOnWindow()) {
        return;
    }
    window.braze.openSession();
};
/**
 * Identifies the user for Braze
 * @param {Number | null} userId User id
 * @private
 */
var changeBrazeUser = function (userId) {
    if (!isBrazeOnWindow()) {
        return false;
    }
    window.braze.changeUser(userId);
};
/**
 * Loads Braze script and initializes the Braze SDK
 * @param {string} apiKey API key to initialise Braze
 * @param {Boolean} enableLogs Enable logging
 * @param {string} appVersion Current app version
 * @public
 */
var bootstrapBraze = function (apiKey, enableLogs, appVersion) {
    if (apiKey === void 0) { apiKey = ''; }
    loadBrazeScript();
    initializeBraze(apiKey, enableLogs, appVersion);
};
/**
 * Subscribe for Braze In-App messages
 */
var subscribeForInAppMessages = function () {
    if (!isBrazeOnWindow()) {
        return;
    }
    window.braze.subscribeToInAppMessage(function (inAppMessage) {
        if (inAppMessage) {
            window.braze.showInAppMessage(inAppMessage);
        }
    });
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/**
 * Loads GTM consent defaults
 * https://developers.google.com/tag-platform/devguides/consent
 */
var loadGTMConsentDefaults = function (baseUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data, countryCode, permissions_1, e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                url = getEndpoint({ baseUrl: baseUrl, endpoint: ENDPOINTS.USER_CONFIG });
                return [4 /*yield*/, axios.get(url)];
            case 1:
                data = (_b.sent()).data;
                countryCode = ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.country_code) || '';
                permissions_1 = isCountryGDPRProtected(countryCode) ? 'denied' : 'granted';
                (function (w, l) {
                    w[l] = w[l] || [];
                    function gtag() {
                        w[l].push(arguments);
                        console.log('initGTMConsentDefaults');
                    }
                    gtag('consent', 'default', {
                        ad_storage: permissions_1,
                        analytics_storage: permissions_1,
                        functionality_storage: permissions_1,
                        personalization_storage: permissions_1,
                        security_storage: 'granted',
                        wait_for_update: 500,
                    });
                })(window, 'dataLayer');
                return [3 /*break*/, 3];
            case 2:
                e_1 = _b.sent();
                console.error('Cannot load GTM consent defaults', e_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Loads GTM Script
 * @param {string} GTM_ID
 */
var loadGTMScript = function (GTM_ID) {
    if (GTM_ID === void 0) { GTM_ID = ''; }
    try {
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js',
            });
            var f = d.getElementsByTagName(s)[0];
            var j = d.createElement(s);
            var dl = l != 'dataLayer' ? "&l=" + l : '';
            j.async = true;
            j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', GTM_ID);
    }
    catch (e) {
        console.error('Cannot load GTM', e);
    }
};

/** Store a ref to common data */
var commonData = {};
/**
 * Checks if GTM is present on window object
 * @return {Boolean}
 */
var isGTMPresent = function () {
    if (!window.dataLayer) {
        console.error('GTM has not been found on the window.');
    }
    return !!window.dataLayer;
};
/**
 * Bootstraps GTM
 * @param {string} GTM_ID
 */
var bootstrapGTM = function (GTM_ID, baseUrl) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!GTM_ID)
                    throw new Error('bootstrapGTM() - missing parameter `GTM_ID`');
                if (!window)
                    throw new Error('bootstrapGTM - `window` not present');
                // First define `dataLayer` if not present
                window.dataLayer = window.dataLayer || [];
                // Load GTM consent defaults before load GTM scripts
                return [4 /*yield*/, loadGTMConsentDefaults(baseUrl)];
            case 1:
                // Load GTM consent defaults before load GTM scripts
                _a.sent();
                // Then load GTM
                loadGTMScript(GTM_ID);
                return [2 /*return*/];
        }
    });
}); };
/**
 * Bootstraps GTM without consent settings (to be loaded directly from GTM)
 * @param {string} GTM_ID
 */
var bootstrapGTMWithoutConsentSettings = function (GTM_ID) {
    if (!GTM_ID)
        throw new Error('bootstrapGTM() - missing parameter `GTM_ID`');
    if (!window)
        throw new Error('bootstrapGTM - `window` not present');
    // First define `dataLayer` if not present
    window.dataLayer = window.dataLayer || [];
    // Then load GTM
    loadGTMScript(GTM_ID);
};
/**
 * Bootstraps GTM on Window.load (if needed)
 * @param {string} GTM_ID
 */
var bootstrapGTMOnWindowLoad = function (GTM_ID, baseUrl) {
    if (!GTM_ID)
        throw new Error('bootstrapGTM() - missing parameter `GTM_ID`');
    if (!window)
        throw new Error('bootstrapGTM - `window` not present');
    // First define `dataLayer` if not present
    window.dataLayer = window.dataLayer || [];
    // Then load GTM on window.load
    window.addEventListener('load', function () {
        // Load GTM consent defaults before load GTM scripts
        void loadGTMConsentDefaults(baseUrl).then(function () {
            // Then load GTM
            loadGTMScript(GTM_ID);
        });
    });
};
/**
 * Extends `commonData` with user props
 * This will get sent through with all events
 * @param {Object} user props
 */
var identifyGTMUser = function (_a) {
    var isPremium = _a.isPremium, uid = _a.uid, countryCode = _a.countryCode, langInterface = _a.langInterface, langCourse = _a.langCourse, userCreated = _a.userCreated;
    commonData = __assign(__assign({}, commonData), { role: isPremium ? 'premium' : 'free', customerId: uid, countryCode: countryCode, languageInterface: langInterface, languageLearned: langCourse, registrationDate: new Date(userCreated * 1000).toString() });
};
/**
 * Send event to GTM
 * @param {string} eventName
 * @param {Object} data
 * @returns void
 */
var sendGTMEvent = function (_a) {
    var eventName = _a.eventName, _b = _a.data, data = _b === void 0 ? {} : _b;
    if (!eventName)
        throw new Error('`eventName` missing');
    /** Construct params */
    var params = __assign(__assign(__assign({}, commonData), data), { event: eventName });
    /** Ensure GTM is present before pushing to the data layer */
    if (isGTMPresent()) {
        window.dataLayer.push(params);
    }
};

/* eslint-disable */
// @ts-nocheck
/**
 * Intercom script is defer-loaded and there is a 'queue' logic.
 * It means Intercom events can be triggered immediately
 * and will be fired as soon as Intercom will be ready.
 *
 * NB: Currently no way to disable TS for a specific block.
 * We do not want to edit a script block from a vendor but we
 * want to keep TS support in general for the `loadIntercomScript` function.
 *
 * @param {string} APP_ID
 */
var loadIntercomScript = function (APP_ID) {
    if (APP_ID === void 0) { APP_ID = ''; }
    try {
        (function () {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === 'function') {
                ic('reattach_activator');
                ic('update', w.intercomSettings);
            }
            else {
                var d_1 = document;
                var i = function () {
                    i.c(arguments);
                };
                i.q = [];
                i.c = function (args) {
                    i.q.push(args);
                };
                w.Intercom = i;
                var l = function () {
                    var s = d_1.createElement('script');
                    s.type = 'text/javascript';
                    s.async = true;
                    s.src = "https://widget.intercom.io/widget/" + APP_ID;
                    var x = d_1.getElementsByTagName('script')[0];
                    x.parentNode.insertBefore(s, x);
                };
                l();
            }
        })();
    }
    catch (e) {
        console.error('Cannot load Intercom', e);
    }
};

// eslint-disable-next-line consistent-return
var bootstrapIntercom = function (appId, params) {
    if (params === void 0) { params = {}; }
    if (!appId) {
        throw new Error('bootstrapIntercom() - missing parameter `appId`');
    }
    // First load script
    loadIntercomScript(appId);
    if (!window.Intercom) {
        return console.warn('bootstrapIntercom() - Intercom has not been found on the window.');
    }
    // Then init Intercom
    window.Intercom('boot', __assign({ app_id: appId }, params));
};

/** Urchin tracking module */
var UTM_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_source_platform',
    'utm_creative_format',
    'utm_marketing_tactic',
];
/** Google Click params */
var GOOGLE_CLICK_PARAMS = ['gclid', 'gclsrc'];
/** Keys used in attribution cookie */
var ATTRIBUTION_COOKIE = {
    NAME: 'BUSUU_ATTRIBUTION',
    SESSION_ID_KEY: 'session_id',
    ATTRIBUTION_KEY: 'attribution',
    PREV_ATTRIBUTION_KEY: 'prev_attribution',
};

/**
 * Loops through available UTM params and pulls them into an object
 * @returns {Object} UTM_PARAMS_PROPS
 */
var getUTMParams = function () {
    return UTM_PARAMS.reduce(function (acc, param) {
        var value = getParameter(param);
        if (value)
            acc[param] = value;
        return acc;
    }, {});
};
/**
 * Loops through available Google Click params and pulls them into an object
 * @returns {Object}
 */
var getGoogleClickParams = function () {
    return GOOGLE_CLICK_PARAMS.reduce(function (acc, param) {
        var value = getParameter(param);
        if (value)
            acc[param] = value;
        return acc;
    }, {});
};
/**
 * Returns common page data
 * @returns {Object} page data
 */
var getPageData = function () {
    var _a;
    return ({
        referral_url: (document === null || document === void 0 ? void 0 : document.referrer) || '',
        page_title: (document === null || document === void 0 ? void 0 : document.title) || '',
        page_url: ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) || '',
    });
};
/**
 *
 * This function should be called:
 * - On App load (to store UTMs and GCLID params)
 * - Before sending any event
 *
 * We currently use `domain_sessionid` from the Snowplow SDK cookie to track sessions on Web.
 * This gets updated after 30 minutes of inactivity.
 *
 * We expect to store an object of type:
 *
 * {
 *   session_id: 'fjeopsjgioesjgoiesji13opfsekpges8fj',
 *   attribution: {
 *     utm_medium: 'foo',
 *     utm_source: 'bar',
 *     utm_term: 'baz',
 *     utm_source: 'hello',
 *     gclid: 'fesge',
 *     gclsrc: 'kopkop,
 *   }
 * }
 *
 * NB: We keep our 'debug' mode here as it can be difficult to understand this logic,
 * we need a quick way to understand what's happening directly from the apps
 *
 * @returns {Object} WEB_ATTRIBUTION_COOKIE
 */
var storeWebAttribution = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a === void 0 ? {} : _a, _g = _f.debug, debug = _g === void 0 ? false : _g, _h = _f.skipStoringCookie, skipStoringCookie = _h === void 0 ? false : _h;
    /**
     * 0. Optional - if `skipStoringCookie` we can choose to ignore the following logic
     * This is very useful for eg in the Homepage when using the `redirect` URL parameter -
     * We want to completely skip decoding any UTMs/GCLIDs at this point as they are URLEncoded
     * inside of the redirect param value.
     * This could look something like this within the Homepage:
     *
     * ```
     *   storeWebAttribution({
     *     debug: false,
     *     skipStoringCookie: !!(getParameter('redirect'))
     *   });
     * ```
     */
    if (skipStoringCookie) {
        if (debug) {
            console.log('storeWebAttribution() -> 0. Skipping storing cookie as `skipStoringCookie` param is `true`');
        }
        /** Early exit */
        return;
    }
    /** 1. First, get the SessionID from Snowplow */
    var currentSessionId = (getSnowplowDuid() || { domain_sessionid: '' }).domain_sessionid;
    if (debug)
        console.log('storeWebAttribution() -> 1. CURRENT SESSION ID: ', currentSessionId);
    try {
        /** 2. Then check if there's a cookie present already for attribution */
        var cookie = Cookies.get(ATTRIBUTION_COOKIE.NAME);
        /** 3. IF YES -> Read cookie and ensure that session ID matches */
        if (cookie) {
            if (debug)
                console.log('storeWebAttribution() -> 2/3. COOKIE WAS FOUND: ', cookie);
            var parsedCookie = JSON.parse(cookie);
            var _j = parsedCookie, _k = ATTRIBUTION_COOKIE.SESSION_ID_KEY, storedSessionId = _j[_k], _l = ATTRIBUTION_COOKIE.ATTRIBUTION_KEY, storedAttributionObj = _j[_l];
            /** 3a. This fixes an edge-case around cookie being set an empty string for session_id (perhaps as it happened before Snowplow loading) */
            if (storedSessionId === '') {
                if (debug) {
                    console.log('`storedSessionId` -> 3a. VARIABLE IS EMPTY STRING, UPDATING SESSION_ID IN COOKIE AND KEEPING EXISTING ATTRIBUTION', storedSessionId);
                }
                /** Ensure that the cookie only updates the `currentSessionId` and keeps the previous attribution */
                var newCookieData = (_b = {},
                    _b[ATTRIBUTION_COOKIE.SESSION_ID_KEY] = currentSessionId,
                    _b[ATTRIBUTION_COOKIE.ATTRIBUTION_KEY] = storedAttributionObj || {},
                    _b);
                /** 3a-1. Now set the cookie with the previous UTMs/GCLIDs */
                Cookies.set(ATTRIBUTION_COOKIE.NAME, JSON.stringify(newCookieData));
                return;
            }
            /** 3b. If the "sessionId" doesn't match, delete the UTMS/GCLID and set the cookie again as empty */
            if (storedSessionId !== currentSessionId) {
                var newCookieData = (_c = {},
                    _c[ATTRIBUTION_COOKIE.SESSION_ID_KEY] = currentSessionId,
                    _c[ATTRIBUTION_COOKIE.ATTRIBUTION_KEY] = {},
                    // We want to add this object to debug an issue that leads to UTM parameters not being sent to us
                    // We suppose that might be caused by the removal of attribution object on session_id change
                    // Issue URL: https://busuucom.atlassian.net/browse/CORE-766
                    _c[ATTRIBUTION_COOKIE.PREV_ATTRIBUTION_KEY] = __assign(__assign({}, storedAttributionObj), { prev_session_id: storedSessionId }),
                    _c);
                if (debug) {
                    console.log('storeWebAttribution() -> 3b. SESSION IDS DONT MATCH, SETTING NEW COOKIE: ', newCookieData);
                }
                /** 3b-1. Now set the cookie with the deleted UTMs/GCLIDs */
                Cookies.set(ATTRIBUTION_COOKIE.NAME, JSON.stringify(newCookieData));
            }
        }
        else {
            if (debug) {
                console.log('storeWebAttribution() ->  4. COOKIE NOT FOUND, SETTING FIRST COOKIE WITH DATA: ', __assign(__assign({}, (getUTMParams() || {})), (getGoogleClickParams() || {})));
                console.log('getUTMParams(): ', getUTMParams());
                console.log('getGoogleClickParams(): ', getGoogleClickParams());
            }
            /** 4. IF NO -> Set a first cookie and retrieve UTM/GCLID params if they exist */
            Cookies.set(ATTRIBUTION_COOKIE.NAME, JSON.stringify((_d = {},
                _d[ATTRIBUTION_COOKIE.SESSION_ID_KEY] = currentSessionId || '',
                _d[ATTRIBUTION_COOKIE.ATTRIBUTION_KEY] = __assign(__assign({}, (getUTMParams() || {})), (getGoogleClickParams() || {})),
                _d)));
        }
    }
    catch (e) {
        if (debug)
            console.log('storeWebAttribution() ->  5. FELL INTO `catch()` BLOCK, SETTING EMPTY COOKIE');
        /** 5. As a fallback, set an empty cookie if the above logic fails */
        Cookies.set(ATTRIBUTION_COOKIE.NAME, JSON.stringify((_e = {},
            _e[ATTRIBUTION_COOKIE.SESSION_ID_KEY] = currentSessionId || '',
            _e[ATTRIBUTION_COOKIE.ATTRIBUTION_KEY] = {},
            _e)));
        return { error: e };
    }
};
/**
 * Returns the stored data in the cookie and enriches it with page data
 * @returns {Object} WEB_ATTRIBUTION_PROPS
 */
var getWebAttribution = function () {
    var onError = function (e) {
        return __assign(__assign({}, getPageData()), (e && { error: e }));
    };
    try {
        var data = Cookies.get(ATTRIBUTION_COOKIE.NAME) || '{}';
        var parsedData = data ? JSON.parse(data) : null;
        if (parsedData && parsedData[ATTRIBUTION_COOKIE.ATTRIBUTION_KEY]) {
            return __assign(__assign({}, parsedData[ATTRIBUTION_COOKIE.ATTRIBUTION_KEY]), getPageData());
        }
        return onError();
    }
    catch (e) {
        return onError(e);
    }
};
/**
 * This function is a part of investigation to debug web attribution cookie issue
 * It returns prev_attribution object in case attribution parameters were wiped out by session_id change
 * Issue URL: https://busuucom.atlassian.net/browse/CORE-766
 * @returns {Object} WEB_ATTRIBUTION_PROPS
 */
var getWebPrevAttribution = function () {
    var onError = function (e) {
        return e
            ? {
                error: e,
            }
            : null;
    };
    try {
        var data = Cookies.get(ATTRIBUTION_COOKIE.NAME) || '{}';
        var parsedData = data ? JSON.parse(data) : null;
        if (parsedData && parsedData[ATTRIBUTION_COOKIE.PREV_ATTRIBUTION_KEY]) {
            return __assign({}, parsedData[ATTRIBUTION_COOKIE.PREV_ATTRIBUTION_KEY]);
        }
        return onError();
    }
    catch (e) {
        return onError(e);
    }
};

var ECOMMERCE_ORIGIN_CONSTANTS = {
    CERTIFICATE_PAYWALL: 'certificate',
    CLAIM_BASIC_FT_PAYWALL_BANNER: 'claim_basic_ft_paywall_banner',
    CLAIM_BASIC_TRIAL_BANNER: 'claim_basic_trial_banner',
    CLAIM_REFERRAL_FT_PAYWALL_BANNER: 'claim_referral_ft_paywall_banner',
    CLAIM_REFERRAL_TRIAL_BANNER: 'claim_referral_trial_banner',
    DISCOUNT_COUPON_FORM: 'discount_coupon_form',
    EXTERNAL_SOURCES: 'external_sources',
    FREE_TRIAL_ONBOARDING: 'free_trial_onboarding',
    LESSONS_LOCKED: 'lesson_locked',
    MEMORISE_ACTIVITY_PAYWALL: 'memorise',
    MERCHANDISING_BANNER: 'merch_banner',
    MERCHANDISING_BANNER_COUNTDOWN: 'merch_banner_countdown',
    ONBOARDING_STUDY_PLAN: 'onboarding_study_plan',
    ONBOARDING_STUDY_PLAN_LAST_CHANCE: 'onboarding_study_plan_last_chance',
    PREMIUM_ACTIVITY_TOOLTIP: 'locked_content',
    PREMIUM_CTA_NAVTOP: 'cta_navtop',
    PRINT_PREMIUM_PAYWALL: 'lesson_summary',
    PROMO_BRAZE: 'promo_braze',
    PROMO_CART_ABANDONMENT: 'cart_abandonment',
    PROMO_GLOBAL: 'promo_global',
    PROMO_TWO_DAY_STREAK: '2_day_streak',
    SMART_REVIEW_ACTIVITY_PAYWALL: 'smart_review',
    UPGRADE_BANNER: 'upgrade_banner',
    FRICTION_WITH_ADS: 'friction_with_ads',
    ONBOARDING_PUSH_NOTIFICATIONS: 'onboarding_push_notifications',
    TIMELINE_BANNER: 'timeline_banner',
    HOMEPAGE_BANNER: 'homepage_banner',
    PAID_SEARCH_BANNER: 'paid_search_banner',
    SEO_BANNER: 'seo_banner',
    UNLOCK_ALL_LESSONS: 'unlock_all_lessons',
    CRM_AUTO_AUTHENTICATION: 'crm_auto_authentication',
    AUTO_AUTHENTICATION: 'auto_authentication',
    RETURNING_OVERLAY: 'returning_overlay',
    SPECIALTY_COURSE: 'specialty_course',
    FRICTION_WITH_REWARDED_ADS: 'friction_with_rewarded_ads',
    STREAK_REPAIR: 'streak_repair',
    GRAMMAR_REVIEW: 'grammar_review',
    GRAMMAR_REVIEW_BANNER: 'grammar_review_banner',
    VOCABULARY_REVIEW_BANNER: 'vocabulary_review_banner',
    MODAL_SURFACE: 'modal_surface',
    SIXTH_LESSON: '6th_lesson',
};

var FILENAME = 'ecommerce-origin-service.ts';
/**
 * Gets the ecommerce origin value from the constants
 */
var getFromConstants = function (type) {
    return ECOMMERCE_ORIGIN_CONSTANTS[type];
};
/**
 * Indicates wether or not an eCommerce Origin
 * type exists based on a given type.
 */
var isTypeDefined = function (type) {
    if (!type) {
        return false;
    }
    return Object.keys(ECOMMERCE_ORIGIN_CONSTANTS).includes(type);
};
/**
 * Removes ecommerce value from storage
 */
var removeEcommerceOriginValue = function () {
    removeStorageItem('ECOMMERCE_ORIGIN');
};
/**
 * Stores an eCommerce Origin type.
 * 1. If an origin storage can't be found,
 *    we delete the previous origin found to avoid
 *    falsy stored values.
 */
var storeEcommerceOriginValue = function (type) {
    if (isTypeDefined(type)) {
        setStorageItem('ECOMMERCE_ORIGIN', type);
    }
    else {
        console.log(FILENAME, "store() - eCommerce type is not found, type: " + type + ".");
        removeEcommerceOriginValue(); // 1
    }
};
/**
 * Returns an eCommerce Origin value from a given type. If no origin is found,
 * and if the utm_medium is not 'direct', it assumes the origin is 'deeplinking'
 * This could be organic traffic, referral from other sites, CRM, CPC. This avoids
 * having events with an unknown origin
 */
var getEcommerceOriginValue = function (type) {
    var eCommerceOrigin = null;
    if (isTypeDefined(type)) {
        eCommerceOrigin = getFromConstants(type);
    }
    if (!eCommerceOrigin) {
        /** We consider something is "direct" if the user has typed in busuu.com into their address bar (no referrer) */
        var isDirect = !(document === null || document === void 0 ? void 0 : document.referrer);
        /** We use 'unknown origin' if we have no clue where they came from (direct hit) */
        eCommerceOrigin = isDirect ? 'unknown_origin' : getFromConstants('EXTERNAL_SOURCES');
    }
    return eCommerceOrigin;
};
/**
 * Returns an eCommerce Origin value previously stored.
 */
var retrieveEcommerceOriginValue = function () {
    var type = getStorageItem('ECOMMERCE_ORIGIN');
    return getEcommerceOriginValue(type);
};

export { ATTRIBUTION_COOKIE, ECOMMERCE_ORIGIN_CONSTANTS, GOOGLE_CLICK_PARAMS, UTM_PARAMS, bootstrapBraze, bootstrapGTM, bootstrapGTMOnWindowLoad, bootstrapGTMWithoutConsentSettings, bootstrapIntercom, changeBrazeUser, getEcommerceOriginValue, getFromConstants, getGoogleClickParams, getPageData, getUTMParams, getWebAttribution, getWebPrevAttribution, identifyGTMUser, isBrazePushBlocked, isBrazePushPermissionGranted, isBrazePushSupported, isGTMPresent, isTypeDefined, loadBrazeScript, loadGTMConsentDefaults, loadGTMScript, loadIntercomScript, openBrazeSession, removeEcommerceOriginValue, requestBrazePushPermission, retrieveEcommerceOriginValue, sendGTMEvent, storeEcommerceOriginValue, storeWebAttribution, subscribeForInAppMessages };
//# sourceMappingURL=index.esm.js.map
